<template lang="pug">
div
  Form(:data="id", :isSubmitting="isSubmitting", @submit="create")
</template>

<script>
import Form from '../shared/Form.vue'
import useIDAdd from './useIDAdd'

export default {
  components: {
    Form,
  },

  setup() {
    const { create, id, isSubmitting } = useIDAdd()

    return {
      id,
      create,
      isSubmitting,
    }
  },
}
</script>
